exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pay-in-modal .pay-in__invoice-radio label {\n  font-family: 'Open Sans Regular', Helvetica, Arial, sans-serif !important;\n  font-size: 0.8rem;\n  font-weight: normal !important;\n  color: #222c3c;\n}\n.pay-in-modal .pay-in__invoice-radio .input-box {\n  width: 11px !important;\n  height: 11px !important;\n}\n.pay-in-modal .pay-in__invoice-radio .input-box-circle {\n  width: 5px !important;\n  height: 5px !important;\n  margin: 2px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0d4bedf4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/ReservationPayIn/Step3Summary.vue
// module id = 2008
// module chunks = 0